import type { App } from 'vue';

import Lottie from '../components/Library/Lottie.vue';
import InfoNotification from '../components/Layout/InfoNotification.vue';

const components = {
  Lottie,
  InfoNotification,
};

export interface ExtensionLibraryComponents {
  Lottie: typeof Lottie;
  InfoNotification: typeof InfoNotification;
}

export const useLibrary = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component);
  }
};
